/**
 * Deployment-specific values.
 *
 * None of these belong in the source: the PayPal link and the contact address
 * change without the app changing, and the path the full version lives under
 * is a property of the server, not of the code. They arrive as build-time
 * variables and every one of them has a defined behaviour when unset, so a
 * missing value degrades a dialog rather than breaking a build.
 */

/** Where the unlocked build is served from. */
export const FULL_APP_PATH: string = import.meta.env.VITE_FULL_APP_PATH ?? '/app/'

/**
 * Cookie nginx reads the key from.
 *
 * The comparison happens in the server config: the browser never learns
 * whether a key is right except by being handed the app or refused.
 */
export const KEY_COOKIE = 'multitimbral_key'

/** How long a correct key is remembered, in seconds. */
export const KEY_MAX_AGE = 60 * 60 * 24 * 180

/** Payment link for the donation, e.g. a PayPal.Me address. */
export const DONATE_URL: string = import.meta.env.VITE_DONATE_URL ?? ''

/** Address a supporter writes to; used to build a prefilled mail link. */
export const CONTACT_EMAIL: string = import.meta.env.VITE_CONTACT_EMAIL ?? ''

/** Suggested amount, in euros. */
export const DONATION_EUR = 5
